package io.horion.cv.styles

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

val AccordionContentStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .padding(
                leftRight = 20.px,
                top = 30.px,
                bottom = 30.px
            )
            .styleModifier {
                property("box-sizing", "border-box")
                property("overflow-x", "hidden")
                property("max-width", "100%")
            }
    }

    Breakpoint.MD {
        Modifier.padding(
            leftRight = 40.px,
            top = 30.px,
            bottom = 30.px
        )
    }

    Breakpoint.LG {
        Modifier.padding(
            leftRight = 50.px,
            top = 30.px,
            bottom = 30.px
        )
    }
}

val FormContentStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .maxWidth(100.percent)
            .styleModifier {
                property("box-sizing", "border-box")
                property("min-width", "0")
                property("overflow", "visible")
            }
    }
}

val FormSectionContentStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .maxWidth(100.percent)
            .padding(
                top = 30.px,
                bottom = 30.px,
                left = 20.px,
                right = 20.px
            )
            .styleModifier {
                property("box-sizing", "border-box")
                property("min-width", "0")
                property("overflow", "visible")
            }
    }

    Breakpoint.MD {
        Modifier.padding(
            top = 30.px,
            bottom = 30.px,
            left = 40.px,
            right = 40.px
        )
    }

    Breakpoint.LG {
        Modifier.padding(
            top = 30.px,
            bottom = 30.px,
            left = 50.px,
            right = 50.px
        )
    }
}

val FormActionSectionStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .styleModifier {
                property("position", "relative")
                property("overflow", "visible")
                property("z-index", "20")
            }
    }
}

val ExtraSectionsGridStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .flexWrap(FlexWrap.Wrap)
            .gap(10.px)
            .styleModifier {
                property("position", "relative")
                property("overflow", "visible")
                property("z-index", "30")
                property("box-sizing", "border-box")
                property("min-width", "0")
            }
    }
}